import React, { useState, useContext, useEffect } from 'react';
import { StyleSheet, Text, Image, View } from 'react-native';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { useTranslation } from 'react-i18next';


import {
  shadowBlackTxt,
  bigFontPc, bigFontSp, fontPc, fontSp,
} from '../../../../../../style/css/CmnStyle';
import { hpContext } from '../../../../HPContext';
import GradationWrap from '../../../../../common/wrap/GradationWrap';


function FunctionItem4() {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;
  const langCode = useContext(hpContext).langCode;
  const windowDimensions = useContext(hpContext).windowDimensions;
  const windowWidth = windowDimensions.width;
  const windowHeight = windowDimensions.height;

  const imgPath = langCode=='ja'? '/assets/img/top/ja/f4.png' : '/assets/img/top/en/f4.png';

  const [ref, inView] = useInView({
    triggerOnce: false, // 一度だけトリガーする
    threshold: 0.1, // スクロールの10%の位置でトリガー
  });


  const animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0)' : 'translateX(-100%)',
  });



  const styles = StyleSheet.create({
    container: {
      flex: 1,
    },

    contentWrap: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: '5%',
      paddingTop: isWide? 10 : 20,
      paddingBottom: isWide? 10 : 30,
      height: '100%',
    },
    imgWrap: {
      flex: 1,
      alignItems: isWide? 'flex-end' : 'center',
      justifyContent: isWide? 'center' : 'flex-end',
      paddingHorizontal: '5%',
      paddingTop: isWide? 25 : 0,
      paddingBottom: isWide? 25 : 0,
      height: '100%',
    },

    title: {
      fontSize: isWide? bigFontPc : bigFontSp,
      fontWeight: 'bold',
      marginBottom: isWide? 30 : 10,
      paddingTop: isWide? 0 : 30,
    },
    description: {
      fontSize: isWide? fontPc : fontSp,
    },

    img: {
      width: isWide? '90%' : '70%',
      height: isWide? windowHeight*0.45 : windowHeight*0.6,
    },
  });

  return (
    <View ref={ref} style={styles.container}>
    <GradationWrap>
    <animated.div style={animation}>
      {/* アニメーションさせたいコンテンツ */}

      <Grid container>
        <Grid xs={0} md={1}></Grid>

        <Grid xs={12} md={4}>
          <View style={styles.imgWrap}>
            {!isWide&&
              <Text style={[shadowBlackTxt, styles.title]}>{t('top.function.f4.title')}</Text>
            }
            <Image
              defaultSource={imgPath}
              resizeMode={'contain'}
              style={styles.img}
            />
          </View>
        </Grid>


        <Grid xs={12} md={5}>
          <View style={styles.contentWrap}>
            {isWide&&
              <Text style={[shadowBlackTxt, styles.title]}>{t('top.function.f4.title')}</Text>
            }

            <Text style={[shadowBlackTxt, styles.description]}>{t('top.function.f4.content')}</Text>
          </View>
        </Grid>

        <Grid xs={0} md={2}></Grid>
      </Grid>

    </animated.div>
    </GradationWrap>
    </View>
  );
}


export default FunctionItem4;